import React from 'react';
import MijnOrganisaties from '../../components/authentication/user/MijnOrganisaties';

const PageMijnOrganisaties: React.FC = () => {

  return (
    <>
      <header className="app-header">
        <h1>Mijn organisaties</h1>
        <p className="header-sub-title center">
          Uw account is gekoppeld aan onderstaande organisaties. U kunt infraplannen.nl gebruiken voor deze organisaties.<br/>
          Per organisatie kunt u de plannen zien die van deze organisatie zijn of gedeeld worden met deze organisatie.
        </p>
      </header>

      <div className="content">
        <MijnOrganisaties />
      </div>
    </>
  );
};

export default PageMijnOrganisaties;